import React from 'react';
export const Header = () => {
  return <header className="mb-8" data-id="element-216">
      <div className="flex items-center justify-center mb-4" data-id="element-217">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-16 object-contain" data-id="element-218" />
      </div>

      <div className="text-center mb-6 text-blue-600 font-semibold text-sm" data-id="element-219">
        Speciaal voor liefdevolle hondeneigenaren
      </div>

      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-blue-800 leading-tight" data-id="element-220">
        Waarom je hond je niet begrijpt en niet goed luistert - ook al doe je
        voor je gevoel alles goed…
      </h1>

      <div className="text-center mb-4 text-lg text-gray-700 leading-relaxed" data-id="element-221">
        Ontdek de onzichtbare taalbarrière die zelfs de meest liefdevolle
        baasjes over het hoofd zien — en hoe je die in 6 stappen doorbreekt
      </div>

      <div className="text-center text-sm text-gray-600 mb-6" data-id="element-222">
        Door Amee de Bruijn, Gediplomeerd Hondengedragsconsultant
      </div>

      <div className="w-full mb-6" data-id="element-223">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inDJ1aV7dcBAqLoekugSLb/Scherm_afbeelding_2025-08-21_om_23.44.08-min.png" alt="Vrouw en haar hond tijdens een wandeling" className="w-full h-auto rounded-lg shadow-md" data-id="element-224" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-225">
          De diepe band die mogelijk is wanneer je je hond écht begrijpt
        </p>
      </div>

      <div className="w-full h-[1px] bg-gray-200 my-6" data-id="element-226"></div>
    </header>;
};